import React from 'react';

const Quote = () => (
  <div className="quote-text">
    <p>
      Mathematics as an expression of the human mind reflects the active will,
      the contemplative reason, and the desire for aesthetic perfection.
      Its basic elements are logic and intuition, analysis and construction,
      generality and individuality.

    </p>
  </div>
);

export default Quote;
